// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/clones';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;
